import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_87: FaireProductEntity = {
  token: "legacy_prod_abbott-87",
  type: "product",
  name: "Small Velvet Pouch with 3D Bee, Black 4×6 L",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/9b9cc80e66d9f19cdaa1ddedecfbae10bbb62e4ce2e73c0155e0789b476e593e.jpeg",
  priceDollars: 10,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_womens-accessories"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
